module.exports = __webpack_public_path__ + "@/assets/img/Notif.5056244a.svg";